import api from "@/services/api"
import type {
  Abilities,
  AbilitiesTactic,
  FavoriteAbility,
  ParserResultGet
} from "@/types/abilities"
import { ListResource } from "@/utils/ListResource"
import type { PostFavorite } from "@/types/favorites"
import type { Pagination } from "@/types/pagination"

export class AbilitiesApi extends ListResource {
  public getAbilities = (page: number, search = "name:", order = "") => {
    this.setPage(page)
    this.setPerPage(12)
    this.setSearch(search)
    this.setOrder(order)

    const filterString = this.search ? `?filter=${this.search}` : ""
    const sortString = this.order_by
      ? this.search
        ? `&sort=${this.order_by}`
        : `?sort=${this.order_by}`
      : ""

    return api.get<Pagination<Abilities>>(
      `/api/v1/abilities${filterString}${sortString}`,
      {
        params: { page: this.page, page_size: this.per_page }
      }
    )
  }

  public getAbility = (id: string) =>
    api.get<Abilities>(`/api/v1/abilities/${id}`)

  public getAbilitiesFilters = (query?: string) => {
    return api.get("/api/v1/abilities_filters", {
      params: {
        query: query
      }
    })
  }

  public postFavoriteAbility = (data: PostFavorite) =>
    api.post(`/api/v1/favorites`, data)

  public getFavoriteAbility = (
    page: number,
    search = "name:",
    order = "",
    perPage = 12
  ) => {
    this.setPage(page)
    this.setPerPage(perPage)
    this.setSearch(search)
    this.setOrder(order)

    const filterString = this.search ? `?filter=${this.search}` : ""
    const sortString = this.order_by
      ? this.search
        ? `&sort=${this.order_by}`
        : `?sort=${this.order_by}`
      : ""

    return api.get<Pagination<FavoriteAbility<Abilities>>>(
      `/api/v1/get_all_favorites${filterString}${sortString}`,
      {
        params: {
          page: this.page,
          page_size: this.per_page,
          abilities: "favorites"
        }
      }
    )
  }

  public postAbility = (data: FormData) =>
    api.post<{ detail: string; ability: Abilities }>(
      "/api/v1/abilities",
      data,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    )

  public updateAbility = (id: string, data: FormData) =>
    api.put<{ detail: string; ability: Abilities }>(
      `/api/v1/abilities/update/${id}`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    )

  public deletePayload = (payloadName: string, abilityId: string) =>
    api.delete<{ detail: string }>(
      `/api/v1/abilities/payload_remove/${payloadName}/${abilityId}`
    )

  public getTactics = () => api.get<AbilitiesTactic[]>("/api/v1/tactics")

  public getParserResults = () =>
    api.get<ParserResultGet[]>("/api/v1/parsers_results")
}
